// Deny-by-default — anything not recognized as non-prod triggers the
// confirm-before-destructive-change modal in feature-flag pages.

const NON_PROD_HOST_MARKERS: ReadonlySet<string> = new Set([
  'localhost',
  '127.0.0.1',
  '0.0.0.0',
]);

const NON_PROD_URL_SUBSTRINGS: readonly string[] = ['dev', 'staging', 'stage', 'sandbox'];

export function isNonProdApi(apiUrl: string): boolean {
  const lower = apiUrl.toLowerCase();

  try {
    const host = new URL(lower).hostname;
    if (NON_PROD_HOST_MARKERS.has(host)) return true;
  } catch {
    /* URL parse failed — fall through to substring check */
  }

  return NON_PROD_URL_SUBSTRINGS.some(marker => lower.includes(marker));
}

export function requiresConfirmation(apiUrl: string): boolean {
  return !isNonProdApi(apiUrl);
}
